import { Component, Input, OnInit } from '@angular/core';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { ArquivoVisualizavel } from '../../components/arquivo-visualizador/arquivo-visualizavel.model';
import { ProcessoDocumento } from '../processo-documento.model';
import { ProcessoDocumentoService } from '../processo-documento.service';

@Component({
  selector: 'app-processo-documento-comparacao-texto-original',
  templateUrl: './processo-documento-comparacao-texto-original.component.html',
  styleUrls: ['./processo-documento-comparacao-texto-original.component.css'],
})
export class ProcessoDocumentoComparacaoTextoOriginalComponent implements OnInit {
  public visivel = false;

  @Input()
  public processoDocumento: ProcessoDocumento;

  public original: ArquivoVisualizavel;
  public texto: string;
  public carregandoTexto: boolean;
  public carregandoOriginal: boolean;

  constructor(
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private processoDocumentoService: ProcessoDocumentoService
  ) {}

  ngOnInit(): void {}

  public visualizar(): void {
    this.visivel = true;
    this.progressoService.modal();
    this.carregandoOriginal = true;
    this.carregandoTexto = true;

    this.processoDocumentoService
      .recuperarConteudoPorId(this.processoDocumento.processo.id, this.processoDocumento.id)
      .then((conteudoOriginal) => {
        this.original = new ArquivoVisualizavel(
          this.processoDocumento.nome,
          this.processoDocumento.tipoArquivo,
          this.processoDocumento.categoriaArquivo,
          conteudoOriginal
        );
        this.carregandoOriginal = false;
        this.esconderProgressoSeNecessario();
      })
      .catch((resposta) => {
        this.original = undefined;
        this.carregandoOriginal = false;
        this.esconderProgressoSeNecessario();
        this.mensagemService.addErro('Erro ao recuperar documento original', resposta.error);
      });

    this.processoDocumentoService
      .recuperarTextoPorId(this.processoDocumento.processo.id, this.processoDocumento.id)
      .then((texto) => {
        this.texto = texto;
        this.carregandoTexto = false;
        this.esconderProgressoSeNecessario();
      })
      .catch((resposta) => {
        this.texto = '';
        this.carregandoTexto = false;
        this.esconderProgressoSeNecessario();
        this.mensagemService.addErro('Erro ao recuperar a url de acesso ao recurso', resposta.error);
      });
  }

  public esconder(): void {
    this.visivel = false;
  }

  private esconderProgressoSeNecessario(): void {
    if (!this.carregandoTexto && !this.carregandoOriginal) {
      this.progressoService.fechar();
    }
  }
}
